import { Link } from 'react-router-dom';
import { openCookiePreferences } from '../../lib/clarity';

export function Footer() {
  return (
    <footer className="py-12 bg-[#1A1A1A] border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-heading text-xl font-semibold text-white block mb-4">ZURIYA</span>
            <p className="text-sm text-stone-400 leading-relaxed">Connecting you with trusted multi-cultural beauty professionals.</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Platform</h4>
            <div className="space-y-2">
              <Link to="/discover" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Discover</Link>
              <Link to="/register?role=provider" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Become a Provider</Link>
              <Link to="/help" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Help Centre</Link>
              <Link to="/contact" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Contact Us</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Legal</h4>
            <div className="space-y-2">
              <Link to="/terms" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Terms &amp; Conditions</Link>
              <Link to="/privacy" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
              <Link to="/cookies" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Cookie Policy</Link>
              <button
                type="button"
                onClick={openCookiePreferences}
                data-testid="footer-cookie-prefs-btn"
                className="block text-left text-sm text-stone-400 hover:text-[#D4AF37] transition-colors"
              >
                Cookie preferences
              </button>
              <Link to="/refunds" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">Refunds & Cancellations</Link>
              <Link to="/trust" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-trust-link">Trust Centre</Link>
              <Link to="/roadmap" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-roadmap-link">Roadmap</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">Get in Touch</h4>
            <div className="space-y-2">
              <a href="mailto:hello@zuriya.co.uk" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">hello@zuriya.co.uk</a>
              <a href="mailto:support@zuriya.co.uk" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">support@zuriya.co.uk</a>
              <a href="mailto:providers@zuriya.co.uk" className="block text-sm text-stone-400 hover:text-[#D4AF37] transition-colors">providers@zuriya.co.uk</a>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-stone-800 space-y-6">
          {/* Trust row, deliberately conservative wording. No compliance certifications, no "verified partner" claims. */}
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-6 gap-y-3 text-xs text-stone-400" data-testid="footer-trust-row">
            <span className="inline-flex items-center gap-1.5">
              <svg className="h-3.5 w-3.5 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M2 7h20v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7zm0 4h20"/></svg>
              Secure payments via Stripe
            </span>
            <span className="inline-flex items-center gap-1.5">
              <svg className="h-3.5 w-3.5 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
              2FA protected accounts
            </span>
            <span className="inline-flex items-center gap-1.5">
              <svg className="h-3.5 w-3.5 text-[#D4AF37]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>
              GDPR-aligned data handling
            </span>
            <Link to="/trust" className="inline-flex items-center gap-1 text-stone-500 hover:text-[#D4AF37] underline-offset-2 hover:underline transition-colors" data-testid="footer-trust-learn-more">
              Learn more in the Trust Centre →
            </Link>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-stone-500 text-sm">&copy; {new Date().getFullYear()} Zuriya Ltd. All rights reserved.</p>
            <a href="https://www.tiktok.com/@zuriyaofficial" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-stone-400 hover:text-[#D4AF37] transition-colors" data-testid="footer-tiktok">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .56.04.81.1v-3.5a6.37 6.37 0 00-.81-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.73a8.19 8.19 0 004.76 1.52V6.81a4.84 4.84 0 01-1-.12z"/></svg>
              @zuriyaofficial
            </a>
          </div>
          <p className="text-[11px] text-stone-500 text-center sm:text-left" data-testid="footer-colophon">
            Zuriya Ltd is registered in England and Wales. Registered with the UK Information Commissioner&apos;s Office under no.
            {' '}<span className="font-mono">ZC178306</span>.
            Reporting Platform Operator under Schedule 23 Finance Act 2022.
            {' '}<Link to="/trust" className="text-stone-400 hover:text-[#D4AF37] underline">Trust Centre</Link>.
          </p>
        </div>
      </div>
    </footer>
  );
}
